<div class="modal-content1">
  <div class="modal-header">
    <div class="d-flex w-100 align-items-center justify-content-between">
      <div class="col-md-10 col">
        <h4 class="modal-marqueeText">Manage Marquee</h4>
      </div>
      <div class="col-sm-auto col-auto ml-auto">
        <button type="button" class="close" (click)="onCancel()">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>
  </div>

  <form [formGroup]="newsForm" (ngSubmit)="onSubmit()" novalidate>
    <div class="modal-body">
      <div class="row">
        <!-- News Title -->
        <div class="col-sm-12">
          <div class="form-group">
            <label for="newsTitle">Marquee Text</label>
            <input
              formControlName="marqueeText"
              type="text"
              id="newsTitle"
              class="form-control"
              placeholder="Enter news marqueeText"
            />
            <div
              *ngIf="f.marqueeText.touched && f.marqueeText.invalid"
              class="text-danger"
            >
              <div *ngIf="f.marqueeText.errors?.required">
                Title is required
              </div>
              <div *ngIf="f.marqueeText.errors?.maxlength">
                Maximum 5000 characters allowed
              </div>
            </div>
          </div>
        </div>

        <!-- News Description -->
        <div class="col-sm-12">
          <div class="form-group">
            <label for="newsDescription"> Text Link</label>
            <textarea
              formControlName="linkText"
              id="newsDescription"
              rows="3"
              class="form-control"
              placeholder="Enter news linkText"
            ></textarea>
            <div
              *ngIf="f.linkText.touched && f.linkText.invalid"
              class="text-danger"
            >
              <div *ngIf="f.linkText.errors?.required">
                Description is required
              </div>
              <div *ngIf="f.linkText.errors?.maxlength">
                Maximum 1000 characters allowed
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <button
        type="submit"
        class="btn btn-success btn-sm m-right-10"
        [disabled]="newsForm.invalid"
        cdkFocusInitial
      >
        <i class="las la-save"></i> Save
      </button>
      <button type="button" class="btn btn-danger btn-sm" (click)="onCancel()">
        <i class="las la-times-circle"></i> Cancel
      </button>
    </div>
  </form>
</div>
